export default __webpack_public_path__ + "static/media/video-banner-2.31e9cf98.jpg";